// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { bool, array } from 'prop-types';
import { useTheme } from '@emotion/react';
import { uniqueId } from 'lodash';
import { SkeletonText } from '@carbon/react';

import { AnalyticsLink } from 'Components/shared';

const StyledECommerceTools = styled.div`
  section {
    margin-bottom: 16px;
    border: 1px solid #e2e2e2;

    h4 {
      font-size: 16px;
      padding: 16px;
      background: #f5f7f9;
    }

    .file {
      display: flex;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #e2e2e2;

      .fileName {
        &.skeleton {
          flex: 1;
        }
      }
    }

    .sectionBody {
      display: flex;
      flex-direction: column;

      a {
        padding: 20px 16px;
        color: #3a3a3a;
        border-bottom: 1px solid #e2e2e2;
      }
    }
  }
`;

const ECommerceTools = ({
  eCommerceTools,
  loading,
}) => {
  const theme = useTheme();

  return (
    <StyledECommerceTools theme={ theme }>
      { loading ? Array.from({ length: 2 }, () => (
        <section key={ uniqueId('section') }>
          <h4><SkeletonText /></h4>
          { Array.from({ length: 3 }, () => (
            <div className="file" key={ uniqueId('eCommerceTools') }>
              <div className="fileName skeleton">
                <SkeletonText />
              </div>
            </div>
          ))}
        </section>
      )) : eCommerceTools.map(item => (
        <section key={ uniqueId('section') }>
          <h4>{ item?.title }</h4>
          <div className="sectionBody">
            { item?.links.map(link => (
              <AnalyticsLink
                key={ uniqueId('link') }
                to={ link?.link }
                target="_blank"
                event={ { action: 'linked_clicked' } }
              >
                { link?.title }
              </AnalyticsLink>
            ))}
          </div>
        </section>
      ))}
    </StyledECommerceTools>
  );
};

ECommerceTools.propTypes = {
  eCommerceTools: array,
  loading: bool,
};

ECommerceTools.displayName = 'ECommerceToolsComponent';

export default ECommerceTools;
